import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "soft" | "danger";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: IconName;
  iconRight?: IconName;
  full?: boolean;
}

export function Button({
  children,
  variant = "primary",
  size = "md",
  icon,
  iconRight,
  full,
  className,
  type = "button",
  ...props
}: ButtonProps) {
  const iconSize = size === "sm" ? 15 : 17;
  return (
    <button
      type={type}
      className={cn("btn", `btn-${variant}`, `btn-${size}`, full && "btn-full", className)}
      {...props}
    >
      {icon && <Icon name={icon} size={iconSize} />}
      {children && <span>{children}</span>}
      {iconRight && <Icon name={iconRight} size={iconSize} />}
    </button>
  );
}
